import { render, staticRenderFns } from "./Colored.vue?vue&type=template&id=e294d756&scoped=true&"
var script = {}
import style0 from "./Colored.vue?vue&type=style&index=0&id=e294d756&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e294d756",
  null
  
)

export default component.exports